import { j as t } from "../../chunks/jsx-runtime.DGlMoOmv.js";
import { R as y, T as v, P as j, C, I as N } from "../../chunks/index.DK0Z0VgS.js";
import r from "react";
import { F as I } from "../../chunks/ChevronDown16.BcSr2mQh.js";
import { c as e } from "../../chunks/index.CxSWpsOB.js";
const d = ({
  children: o,
  className: s
}) => /* @__PURE__ */ t.jsx("div", { className: e("tw-flex tw-flex-col tw-gap-4 tw-pl-2 tw-pb-2 tw-pt-2 tw-pr-24 tw-body-2-m", s), children: o });
d.displayName = "ItemSelectDropdownItem";
const m = ({
  children: o,
  onSelect: s,
  className: c,
  triggerClassName: p,
  maxHeight: u = 300,
  avoidCollisions: f = !1,
  selectedIndex: n = 0
}) => {
  const [i, h] = r.useState(!1), g = (a) => {
    s?.(a);
  }, b = r.Children.toArray(o)[n], x = r.Children.toArray(o), l = "tw-flex tw-flex-col tw-gap-4 tw-pl-12 tw-pb-8 tw-pt-8 tw-pr-12 tw-body-2-m";
  return /* @__PURE__ */ t.jsxs(y, { onOpenChange: h, children: [
    /* @__PURE__ */ t.jsx(v, { asChild: !0, children: /* @__PURE__ */ t.jsxs("div", { className: e("tw-bg-base-white tw-relative tw-border tw-rounded-2 focus:tw-outline-none focus-visible:tw-outline-none focus:tw-ring-0 focus-visible:tw-ring-0 tw-cursor-pointer hover:tw-border-gray-900 tw-transition-colors tw-duration-200", i ? "tw-border-gray-900" : "tw-border-gray-300", l, p), children: [
      b,
      /* @__PURE__ */ t.jsx(I, { className: e("tw-size-16 tw-transition-transform tw-duration-200 tw-shrink-0 tw-absolute tw-right-8 tw-top-1/2 -tw-translate-y-1/2", i && "tw-rotate-180") })
    ] }) }),
    /* @__PURE__ */ t.jsx(j, { children: /* @__PURE__ */ t.jsx(C, { side: "bottom", align: "start", sideOffset: 4, avoidCollisions: f, className: e("tw-z-[9999] tw-overflow-hidden tw-rounded-4 tw-bg-base-white tw-p-8 tw-text-gray-900 tw-shadow-lg tw-w-[var(--radix-dropdown-menu-trigger-width)] data-[state=open]:tw-animate-in data-[state=closed]:tw-animate-out data-[state=closed]:tw-fade-out-0 data-[state=open]:tw-fade-in-0 data-[state=closed]:tw-zoom-out-95 data-[state=open]:tw-zoom-in-95 data-[side=bottom]:tw-slide-in-from-top-2", c), children: /* @__PURE__ */ t.jsx("div", { className: e("tw-w-full tw-overflow-y-auto", `tw-max-h-[${u}px]`), children: /* @__PURE__ */ t.jsx("div", { children: x.map((a, w) => r.isValidElement(a) ? /* @__PURE__ */ t.jsx(N, { className: e(l, "tw-relative tw-select-none tw-outline-none tw-bg-white tw-transition-colors hover:tw-bg-gray-100", n === w && "tw-bg-gray-100"), onClick: () => g(w), children: a }, w) : null) }) }) }) })
  ] });
};
m.displayName = "ItemSelectDropdown";
m.Item = d;
export {
  m as ItemSelectDropdown
};
//# sourceMappingURL=index.js.map
